import styled from 'styled-components';
import { RadioGroup } from '@lendi-ui/radio';
import { mb, ml, mt } from '@lendi-ui/spacing';

export const StyledRadioGroup = styled(RadioGroup)`
  legend {
    display: none;
  }
`;

export const RadioButton = styled(RadioGroup.Radio)`
  ${mb('nil')}
`;

export const RadioButtonBlock = styled(RadioButton)`
  ${mt('sm')}

  &:first-child {
    ${mt('nil')}
  }
`;

export const RadioButtonInline = styled(RadioButton)`
  ${ml('sm')}

  &:first-child {
    ${ml('nil')}
  }
`;
